module.exports = __webpack_public_path__ + "static/media/Card8.0198da8c.png";